import { IClient } from '../types/Client'

export const getLabelNames = (client: IClient) => {
	const clientLabels = client.labels

	return clientLabels.reduce(
		(acc: string[], label) => {
			if (label) acc.push(label.labelName)
			return acc
		},
		[]
	)
}